import { policyType as PolicyType } from '@ourbranch/lookups';

import { getBillingDay } from './billing-day';

export const PAYMENT_SCHEDULE_VIEWED = 'Payment Schedule Viewed';

// Where the modal opened: Modify Quote's policy card, or read-only on Checkout (#36363).
export const PaymentScheduleSource = Object.freeze({
  ModifyQuote: 'modify-quote',
  Checkout: 'checkout'
});

// Policy line keys (see policy-cards/policy-lines.js) to the policy type each line sells. Renters on an
// auto policy is the auto policy.
const policyTypeByLine = {
  home: PolicyType.Home,
  condo: PolicyType.Condo,
  auto: PolicyType.Auto,
  renters: PolicyType.Renters
};

// Options that sell two lines. HB and AB are one line picked from Home & Auto, so they aren't.
const bundleOptions = new Set([PolicyType.HABundle, PolicyType.ARBundle, PolicyType.CABundle]);

/**
 * Properties for `Payment Schedule Viewed` (#36360), for one policy line from `getPolicyLines`.
 * `agencyId` is the agent's affinity code, the agency identity the rest of staff-fe reports.
 */
export const getPaymentScheduleViewedProperties = ({ policy, offerId, selectedOption, state, source, session }) => ({
  offerId,
  policyType: policyTypeByLine[policy.key] ?? null,
  isBundle: bundleOptions.has(selectedOption),
  source,
  paymentMethod: policy.paymentMethod ?? null,
  paymentFrequency: policy.paymentType ?? null,
  numberOfPayments: policy.schedule?.length ?? 0,
  effectiveDate: policy.effectiveDate ?? null,
  billingDayMode: getBillingDay(policy)?.mode ?? null,
  isAgency: Boolean(session?.isAgency),
  agencyId: session?.user?.affinityCode ?? null,
  state: state ?? null
});
